import NavrhUzneseniaVladyEditPage from './NavrhUzneseniaVladyEditPage';

export default NavrhUzneseniaVladyEditPage;
